import { Component }      from '@angular/core';
import { BooksComponent } from './books.component';

@Component({
  selector: 'dra-recent-books',
  templateUrl: 'books.component.html',
})
export class RecentBooksComponent extends BooksComponent {
  public title: string = 'Recent books';
  public searchParams: {
    search?: string,
    category_id?: number,
    bookmarked?: number,
    page?: number,
    per_page?: number,
    order_by?: string,
  } = {
    search: '',
    category_id: 0,
    bookmarked: 0,
    page: 1,
    per_page: 20,
    order_by: 'last_read'
  };
  public showSearch = {
    search: true,
    category_id: true,
    bookmarked: true,
    per_page: true,
    order_by: false,
  };
  public page = 'RecentBooks';
}



// WEBPACK FOOTER //
// ./src/components/books/recent-books.component.ts